export function HubSpotRichText({ content, type }) {
  if (!content.length) {
    return null;
  }

  if (type === 'TEXT') {
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  }

  return null;
}
